import { AbortableEventData, EventData, EventListener } from '../event/index.js';
class AbortableFetchEvent extends AbortableEventData {
    constructor({ abort }) {
        super(abort);
    }
}
class AbortableFetchEventListener extends EventListener {
    constructor() {
        super(AbortableFetchEvent);
    }
}
class FetchEvent extends EventData {
    constructor({ data, error } = {}) {
        super();
        this.data = data;
        this.error = error;
    }
}
class FetchEventListener extends EventListener {
    constructor() {
        super(FetchEvent);
    }
}
export { AbortableFetchEvent, AbortableFetchEventListener, FetchEvent, FetchEventListener, };
//# sourceMappingURL=fetchable.js.map